import { render, staticRenderFns } from "./CarouselArrow.vue?vue&type=template&id=147005cc&scoped=true&"
import script from "./CarouselArrow.vue?vue&type=script&lang=js&"
export * from "./CarouselArrow.vue?vue&type=script&lang=js&"
import style0 from "./CarouselArrow.vue?vue&type=style&index=0&id=147005cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147005cc",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/CarouselArrow.vue
// module id = 162
// module chunks = 0